import * as DOMPurify from 'dompurify';
/*
 we had a use case of users who wanted to navigate to an article from custom header code, so allowing widget sdk usage was a simple, but naive solution (see https://jira.wixpress.com/browse/WA-18398)
 So to avoid breaking users, we are limiting this exception only to the usage of __answersWidgetSdk.goToArticle
 Note: this should eventually be removed and replaced with a non JS/SDK solution (delcarative attribute such as data-article-id?) but as we can't really know who is using it we're leaving it for backwards compat.
 Note 2: telemtry (in form of devents) might be a possible solution to the "an't really know who is using it" problem
*/
var VALID_SDK_USAGE_PATTERN = /^(window\.)?__answersWidgetSdk\.goToArticle\(['"][a-f\d-]{36}['"]\);?$/;
export var sanitizeExceptWidgetSdk = function (html) {
    // until we have a better solution for SSR (isomorphic dompurify)
    if (typeof window === 'undefined' || !DOMPurify.isSupported)
        return '';
    DOMPurify.addHook('uponSanitizeAttribute', function (_, ev) {
        if (ev.attrName === ('onclick')) {
            if (ev.attrValue.match(VALID_SDK_USAGE_PATTERN)) {
                ev.forceKeepAttr = true;
            }
        }
    });
    var cleanHtml = DOMPurify.sanitize(html, { ADD_ATTR: ['target'] });
    DOMPurify.removeAllHooks();
    return cleanHtml;
};
//# sourceMappingURL=sanitize-html.js.map